import { Button } from "@/components/ui/button";
import { CheckCircle2, FileText, UploadIcon, XCircle } from "lucide-react";
import { FileUploadState } from "..";

interface RenderContentProps {
  state: FileUploadState;
  onFileRemove: () => void;
  errorMessage: string;
  maxFileSize: number;
}

export function RenderContent({
  state,
  onFileRemove,
  errorMessage,
  maxFileSize,
}: RenderContentProps) {
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  if (state.status === "uploading") {
    return (
      <>
        <UploadIcon className="w-8 h-8 text-blue-500 mb-2 animate-spin" />
        <span className="font-semibold text-gray-700 text-center">
          Enviando documento...
        </span>
        <span className="text-xs text-gray-500 mt-1">{state.file?.name}</span>
      </>
    );
  }

  if (state.status === "success") {
    return (
      <>
        <CheckCircle2 className="w-8 h-8 text-green-600 mb-2" />
        <span className="font-semibold text-green-700 text-center">
          Envio completo!
        </span>
        <span className="text-xs text-green-600 mt-1">{state.file?.name}</span>
        <Button
          variant="ghost"
          size="sm"
          className="mt-2 text-green-700 hover:text-green-800"
          onClick={(e) => {
            e.stopPropagation();
            onFileRemove();
          }}
        >
          Remover
        </Button>
      </>
    );
  }

  if (state.status === "error") {
    return (
      <>
        <XCircle className="w-8 h-8 text-red-600 mb-2" />
        <span className="font-semibold text-red-700 text-center">
          Erro no envio
        </span>
        <span className="text-xs text-red-600 mt-1">{state.file?.name}</span>
        {errorMessage && (
          <span className="text-xs text-red-600 text-center max-w-xs">
            {errorMessage}
          </span>
        )}
        <Button
          variant="ghost"
          size="sm"
          className="mt-2 text-red-700 hover:text-red-800"
          onClick={(e) => {
            e.stopPropagation();
            onFileRemove();
          }}
        >
          Remover
        </Button>
      </>
    );
  }

  if (state.file) {
    return (
      <>
        <FileText className="w-8 h-8 text-gray-400 mb-2" />
        <span className="font-semibold text-gray-700 text-center">
          {state.file.name}
        </span>
        <span className="text-xs text-gray-500 mt-1">
          {formatFileSize(state.file.size)}
        </span>
        <Button
          variant="ghost"
          size="sm"
          className="mt-2"
          onClick={(e) => {
            e.stopPropagation();
            onFileRemove();
          }}
        >
          Remover
        </Button>
      </>
    );
  }

  return (
    <>
      <UploadIcon className="w-8 h-8 text-gray-400 mb-2" />
      <span className="font-semibold text-gray-700 text-center">
        Arraste ou solte aqui
      </span>
      <span className="text-xs text-gray-500 mt-1 text-center">
        Ou clique para selecionar arquivo CSV
      </span>
      <span className="text-xs text-gray-400 mt-1">
        Tamanho máximo: {maxFileSize}MB
      </span>
    </>
  );
}
